import { PRICING_RATES } from "@/configs/pricing";

export interface ModelTokens {
  inputTokens: number;
  outputTokens: number;
  cachedInputTokens: number;
  cacheCreationTokens: number;
}

export class ThreadCost {
  readonly costsByModel: Record<string, ModelTokens>;

  constructor(costsByModel: Record<string, ModelTokens> = {}) {
    this.costsByModel = costsByModel;
  }

  /**
   * 総コストを計算（USD）
   */
  getTotalCost(): number {
    return Object.entries(this.costsByModel).map(([modelName, tokens]) => {
      const rates = PRICING_RATES[modelName as keyof typeof PRICING_RATES];

      const inputCost = (tokens.inputTokens / 1000000) * rates.input;
      const outputCost = (tokens.outputTokens / 1000000) * rates.output;
      const cachedInputCost = (tokens.cachedInputTokens / 1000000) * rates.cached;
      // CacheCreationはAnthropic固有で常にinputの1.25倍
      const cacheCreationCost = (tokens.cacheCreationTokens / 1000000) * rates.input * 1.25;

      return inputCost + outputCost + cachedInputCost + cacheCreationCost;
    }).reduce((acc, cost) => acc + cost, 0);
  }
}
